import React, { useCallback } from 'react'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function NavItem({ icon, label, route }) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const handleClick = useCallback(() => navigate(route), [navigate, route])

  return (
    <ListItem disablePadding onClick={handleClick}>
      <ListItemButton>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={t(label)} />
      </ListItemButton>
    </ListItem>
  )
}
